import { render, staticRenderFns } from "./QuickLinksHoldPopup.vue?vue&type=template&id=809cddb4&"
import script from "./QuickLinksHoldPopup.vue?vue&type=script&lang=js&"
export * from "./QuickLinksHoldPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports